interface NotificationCodeMapping {
    [key: string]: string | string[]
}

interface NotificationActiveTab {
    code: string
}

interface NotificationErrorResponse {
    code: string
    message: string
}
export interface NotificationActiveTabs {
    data: {
        notifications: NotificationActiveTab[]
    }
}

export const notificationCodeConfig: NotificationCodeMapping = {
    authorization: 'property.for_authorization',
    documents: ['document.rental_expiring_soon', 'document.brokerage_expiring_soon'],
    activities: 'activity.reminder',
    other: 'other.property_website_sync_failed',
    offers: 'contact.profile_match',
}

export interface NotificationDeliveriesParams {
    'filter[notification.code]'?: string | string[]
    'filter[status]'?: string[]
    limit?: number
}

export interface NotificationDeliveryBase {
    deliveryId: number
    createdAt: string
    status: 'read' | 'unread'
    title: string
    message: string
}

export interface NotificationAuthorization extends NotificationDeliveryBase {
    property: {
        id: number
        internalAppId: number
        propertyService: string
        propertyStatus: string
        propertyStatusId: number
        propertyType: string
    }
}

export const isNotificationAuthorization = (item: NotificationDeliveryBase): item is NotificationAuthorization =>
    'property' in item && 'propertyStatusId' in (item as NotificationAuthorization).property

export interface NotificationDocument extends NotificationDeliveryBase {
    document: {
        contactName: string
        contactType: string
        documentTypeName: string
        documentValidityDate: string
        fileId: number
        fileInternalAppId: number
        fileName: string
        parentId: number
        parentInternalAppId: number
        parentModule: string
        parentName: string
        parentLocation: string | null
    }
}

export interface NotificationActivity extends NotificationDeliveryBase {
    activity: {
        id: number
        title: string
        activityTypeId: number
        activityTypeName: string
        dateFrom: string
        timeFrom: string
        minutesBefore: number
        leadTime: string
        contactId: number | null
    }
}
export interface NotificationWebsiteSync extends NotificationDeliveryBase {
    other: {
        propertyId: number
        propertyInternalAppId: number
        websiteId: number
        websiteInternalAppId: number
        websiteTitle: string
    }
}
export interface NotificationMatchedOffer extends NotificationDeliveryBase {
    contact: {
        contactId: number
        contactName: string | null
        contactType: string
        profileId: number
        profileService: string | null
        propertyType: string | null
        matchedPropertyCount: number
        matchedPropertyIds: number[]
        triggerPropertyId: number | null
    }
}

export interface NotificationDeliveriesData {
    items: (NotificationAuthorization | NotificationDocument | NotificationActivity | NotificationWebsiteSync | NotificationMatchedOffer)[]
    totalCount: number
}

export interface NotificationDeliveriesResponse {
    data: NotificationDeliveriesData
    error: NotificationErrorResponse | string | null
}

export type NotificationUpdateParams = { deliveryIds: number[] } | { all: true; notificationCodes: string[] }

export type RestoreNotificationsParams = { deliveryIds: number[] }

export interface NotificationUpdateResponse {
    data: {
        updatedCount: number
        updatedIds: number[]
    }
    error: NotificationErrorResponse | string | null
}

export interface NotificationUnreadCountResponse {
    data: {
        total: number
        byCodes: Record<string, number>
    }
    error: NotificationErrorResponse | string | null
}

export interface NotificationPreferenceChannel {
    notificationChannelId: number
    channelCode: string
    enabled: boolean
    notifyDaysBefore: number | null
}

export interface NotificationPreference {
    notificationId: number
    notificationCode: string
    notificationName: string
    supportsNotifyDaysBefore: boolean
    channels: NotificationPreferenceChannel[]
}

export interface NotificationPreferencesResponse {
    data: {
        preferences: NotificationPreference[]
    } | null
    error: NotificationErrorResponse | string | null
}

export interface NotificationPreferenceUpdateItem {
    notificationId: number
    notificationChannelId: number
    enabled: boolean
    notifyDaysBefore?: number | null
}

export interface NotificationPreferencesUpdateParams {
    channelPreferences: NotificationPreferenceUpdateItem[]
}

export interface NotificationPreferencesUpdateResponse {
    data: {
        updatedCount: number
    } | null
    error: NotificationErrorResponse | string | null
}
